import React, { FC, memo, ReactNode, useState, useEffect, useContext, useMemo } from 'react'

import { Elements } from '@stripe/react-stripe-js'
import { Stripe, StripeElementsOptions, loadStripe } from '@stripe/stripe-js'

import { AppContext, railsContext } from 'Const'

interface Props {
  children: ReactNode
  onPaymentError(error?: string): void
}

const PaymentForm: FC<Props> = ({ children, onPaymentError }) => {
  const { account, cart, shop } = useContext(AppContext)
  const { currency } = shop

  const environmentKey =
    'stripeEnvironmentKeys' in railsContext
      ? railsContext.stripeEnvironmentKeys[currency] || railsContext.stripeEnvironmentKeys.default
      : ''

  const [stripe, setStripe] = useState<Stripe | null>(null)

  useEffect(() => {
    loadStripe(environmentKey)
      .then((stripe) => {
        setStripe(stripe)
      })
      .catch((reason) => onPaymentError(reason))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [environmentKey])

  const options: StripeElementsOptions = useMemo(
    () => ({
      // TODO: improve Money type to retrieve subunits and remove round
      amount: Math.round(cart.totalMoney * 100),
      currency: currency.toLowerCase(),
      mode: 'payment',
      onBehalfOf: account.ownerStripeAccount?.stripeId,
      paymentMethodCreation: 'manual',
      paymentMethodTypes: ['card'],
      appearance: {
        theme: 'stripe',
      },
    }),
    [account.ownerStripeAccount?.stripeId, cart.totalMoney, currency],
  )

  return stripe && cart.totalMoney > 0 ? <Elements {...{ options, stripe }}>{children}</Elements> : null
}

export default memo(PaymentForm)
